import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CustomDesignPage } from '../../models/custom-design-page.model';

@Component({
	selector: 'app-add-edit-design-page-description',
	templateUrl: './add-edit-design-page-description.component.html'
})
export class AddEditDesignPageDescriptionComponent implements OnInit {

    description: string = '';
    newTemplate: boolean = false;
	isDuplicate: boolean = false;
    page: CustomDesignPage;

	constructor(
		private dialogRef: MatDialogRef<AddEditDesignPageDescriptionComponent>,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		if (this.data.page) {
            this.page = this.data.page;
            this.description = this.page.Description;
		}
		if (this.data.newTemplate) {
			this.newTemplate = this.data.newTemplate;
		}
		if (this.data.isDuplicate) {
			this.isDuplicate = true;
		}
	}

	ngOnInit() {
        
	}

	saveClick() {
        this.page.Description = this.description;
		this.dialogRef.close(this.page);
	}

	closeClick() {
		this.dialogRef.close(null);
	}

}
